package com.iptvplayer.shared.data.remote.api

import com.iptvplayer.shared.data.remote.dto.*
import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.http.*
import com.iptvplayer.shared.util.Constants

class FavoriteApi(private val client: HttpClient) {
    suspend fun getFavorites(): List<FavoriteDto> =
        client.get("${Constants.BASE_URL}/api/favorites").body()

    suspend fun addFavorite(request: AddFavoriteRequestDto): FavoriteDto =
        client.post("${Constants.BASE_URL}/api/favorites") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()

    suspend fun removeFavorite(contentId: String): SuccessResponseDto =
        client.delete("${Constants.BASE_URL}/api/favorites/$contentId").body()
}
